import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  { useEffect, useState } from "react";
import {  faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button,  Modal, Spinner } from 'react-bootstrap';
import RegisterTextbox from '../../components/RegisterTextBox';
import TableComponent from '../../components/TableComponent';
import API from '../../api/axiosConfig';
import { useParams } from 'react-router';
import RegisterSelect from '../../components/RegisterSelect';
import TestPreLoader from '../TestPreLoader/TestPreLoader';

function ProjectRisk() {
    const columns = [
        { name: "المرحلة", key: "phase_name" },
        { name: " الوصف", key: "description" },
        { name: "مستوى التأثير", key: "impact_level_string" },
        { name: "الاحتمالية", key: "probability_string" },
        { name: "الحالة", key: "status_string" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([])
    const [error, setError] = useState([])
    const [phases, setPhases] = useState('')
    const [description, setDescription] = useState('');
    const [impectlevel, setImpactLevel] = useState(Date.now())
    const [probability, setProbability] = useState(Date.now())
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [message , setMessage] = useState('');


    
    const handleRisk = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append('project_id', id);
        formData.append('phase_id', phases);
        formData.append('description', description);
        formData.append('impactlevel', impectlevel);
        formData.append('probability', probability);

        try {
            const res = await API.post(`/projectrisk/risk/store`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const data = await res;
            if (data.status === 200) {
                setPhases('');
                setDescription('');
                setImpactLevel('');
                setProbability('');
                setError([]);

                setShowModal(false);
                setIsSubmitting(false);
                setRows(data.data);
                setTableReloadKey(Date.now());
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
            setError(error.response?.data?.errors || {});
        }
    };

    const dropdownOptions = [
        { label: "خطة التخفيف", route: `/riskmitigation/:id` },
    ];

    const [phase , setPhase] = useState({});

    const getPhases = async () => {
        try {
            const response = await API.get(`/projectphase/${id}/all`);
            const data = await response;
            setPhase(data.data);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setError(error.response.data.errors);
            setMessage(error.response.data.message);
        }
    };

    useEffect(() => {
        getPhases();
    }, []);

    if (loading) return <TestPreLoader />
    return (
        <>
            <div className="printcasedata-container">

                <div className="archive-report">
                    <span className="add-row-ta archiveAdd" onClick={() => setShowModal(true)}>
                        <FontAwesomeIcon icon={faPlus} /> إضافة
                    </span>
                </div>

                <TableComponent
                    apiUrl={`/projectrisk/${id}`}
                    columns={columns}
                    title=" مخاطر المشروع"
                    triggerReload={tableReloadKey}
                    dropdownOptions={dropdownOptions}
                />
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                // className="modal-table small-modall archModal archive-modal"
                //   dialogClassName="fit-content-modal"
                
            >
                <Modal.Header>
                    <Modal.Title>إضافة مخاطر</Modal.Title>
                    <Button
                        className="custom-close-button"
                        variant="link"
                        onClick={() => setShowModal(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} className="closeModal" />
                    </Button>
                </Modal.Header>
                <Modal.Body style={{marginTop:"80px"}}>
                    
                    <RegisterSelect id="phase"
                  label="المرحلة"
                  stylee={{ width: "100%" }}
                  parentStyle={{ width: "80%" }}
                  options={[
                    { value: "", label: " اختر  المرحلة " },
                    ...phase.map((p) => ({ value: p.id, label: p.name }))
                    
                  ]}
                  name="phases"
                  value={phases}
                  onChange={(e) => setPhases(e.target.value)}
                />
                    {error && error.phases && <span className="error">{error.phases[0]}</span>}
                    <RegisterSelect id="impectlevel"
                  label=" مستوى التأثير"
                  stylee={{ width: "100%" }}
                  parentStyle={{ width: "80%" }}
                  options={[
                    { value: "", label: " اختر  مستوى التأثير " },
                    { value: "0", label: "  منخفض" },
                    { value: "1", label: "  متوسط" },
                    { value: "2", label: "  مرتفع" },
                    
                  ]}
                  name="impactLevel"
                  value={impectlevel}
                  onChange={(e) => setImpactLevel(e.target.value)}
                />
                 <RegisterSelect id="probability"
                  label=" الاحتمالية"
                  stylee={{ width: "100%" }}
                  parentStyle={{ width: "80%" }}
                  options={[
                    { value: "", label: " اختر  الاحتمالية " },
                    { value: "0", label: " منخفض " },
                    { value: "1", label: " متوسط" },
                    { value: "2", label: " مرتفع" },
                    
                  ]}
                  name="probability"
                  value={probability}
                  onChange={(e) => setProbability(e.target.value)}
                />
                    

                    <RegisterTextbox label="الوصف" type="text" value={description} onChange={(e) => setDescription(e.target.value)} stylee={{ width: "100%" }} parentStyle={{ width: "80%" }}/>
                    {error && error.description && <span className="error">{error.description[0]}</span>}
                   
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        إغلاق
                    </Button>
                    {
                        isSubmitting ? (
                            <Button variant="primary" disabled>
                                <Spinner animation="border" size="sm" />
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={handleRisk}>
                                حفظ
                            </Button>
                        )
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ProjectRisk;
